import { render, staticRenderFns } from "./objetivos-definidos-registrar.vue?vue&type=template&id=7f1c50b6&scoped=true&"
import script from "./objetivos-definidos-registrar.vue?vue&type=script&lang=js&"
export * from "./objetivos-definidos-registrar.vue?vue&type=script&lang=js&"
import style0 from "./objetivos-definidos-registrar.vue?vue&type=style&index=0&id=7f1c50b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c50b6",
  null
  
)

export default component.exports